var map = {
	"./bg.png": 8853,
	"./制造&商贸企业.png": 9575,
	"./制造&商贸企业hover.png": 2823,
	"./危化运输.png": 3617,
	"./危化运输hover.png": 6981,
	"./商砼运输.png": 4233,
	"./商砼运输hover.png": 380,
	"./城市环卫.png": 4980,
	"./城市配送.png": 9469,
	"./大件运输.png": 4587,
	"./家具运输.png": 407,
	"./家具运输hover.png": 4636,
	"./快消品运输.png": 4448,
	"./快速运输.png": 2429,
	"./挖机运输.png": 5816,
	"./数字仓储.png": 45,
	"./数字政务.png": 9895,
	"./汽贸运输.png": 9825,
	"./渣土运输.png": 9029,
	"./港口物流.png": 4504,
	"./煤炭运输.png": 8276,
	"./生物冷链.png": 812,
	"./生鲜冷链.png": 8545,
	"./生鲜冷链hover.png": 5173,
	"./行业协会.png": 4399,
	"./钢铁运输.png": 2470,
	"./零担专线.png": 3750
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3485;